import React, { useState } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import axios from "axios";
import BtnLoader from "Components/Common/Loader/BtnLoader";
import { loadDecrypted } from "Common Usage/localStorageUtils"; // <-- added

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 400,
  bgcolor: "background.paper",
  border: "none",
  borderRadius: 8,
  boxShadow: 24,
  p: 4,
};

const WarningPopup = ({
  warnPopupOpen,
  handleClose,
  avatarUrl,
  username,
  fetchUsers,
  userId,
}) => {
  const [idBtnLoading, setIdBtnLoading] = useState(false);

  const userMarkedAsdeleted = () => {
    setIdBtnLoading(true);

    let config = {
      method: "put",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/account-delete/markAsDeleted/${userId}`,
      headers: {},
      data: "",
    };

    axios
      .request(config)
      .then(async (response) => {
        console.log(response.data);

        // ─────────────────────────────────────────────────────────
        // Create staff activity log for user deletion (mark as deleted)
        // ─────────────────────────────────────────────────────────
        try {
          const staffData = loadDecrypted("HeartConnect-StaffData");
          const staffId = staffData?._id || staffData?.id || "";
          const staffName = staffData?.fullName || staffData?.name || "Unknown";

          if (staffId) {
            await axios.post(
              `${process.env.REACT_APP_API_URL}/staffs-activity-log/create-staffs-activity`,
              {
                staff: staffId,
                action: "MARK_USER_DELETED",
                description: `Staff ${staffName} marked user ${username} (${userId}) as deleted`,
              },
              { headers: { "Content-Type": "application/json" } }
            );
          }
        } catch (logErr) {
          console.error("Failed to create staff activity log:", logErr);
        }
        // ─────────────────────────────────────────────────────────

        setIdBtnLoading(false);
        handleClose();
        fetchUsers();
      })
      .catch((error) => {
        console.log(error);
        setIdBtnLoading(false);
        handleClose();
      });
  };

  return (
    <Modal
      open={warnPopupOpen}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <div className="w-full">
          <div className="mb-4 flex items-center">
            <img
              src={avatarUrl}
              alt="Avatar"
              className="mr-2 h-14 w-14 rounded-full"
            />
            <h2 className="text-xl font-semibold tracking-wide">{username}</h2>
          </div>
          <p className="mb-6 tracking-wide">Do you want to delete this user?</p>
          <div className="flex justify-end space-x-4 tracking-wide">
            <button
              className="rounded bg-gray-300 px-4 py-2 text-gray-800 hover:bg-gray-400"
              onClick={handleClose}
            >
              Cancel
            </button>

            {idBtnLoading ? (
              <button className="rounded bg-[#c51369] px-4 py-2 text-white hover:bg-[#a10f5b]">
                <BtnLoader />
              </button>
            ) : (
              <button
                onClick={userMarkedAsdeleted}
                className="rounded bg-[#c51369] px-4 py-2 text-white hover:bg-[#a10f5b]"
              >
                Delete
              </button>
            )}
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default WarningPopup;






// import React, { useState } from "react";
// import Box from "@mui/material/Box";
// import Modal from "@mui/material/Modal";
// import axios from "axios";
// import BtnLoader from "Components/Common/Loader/BtnLoader";

// const style = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: "90%",
//   maxWidth: 400,
//   bgcolor: "background.paper",
//   border: "none",
//   borderRadius: 8,
//   boxShadow: 24,
//   p: 4,
// };

// const WarningPopup = ({
//   warnPopupOpen,
//   handleClose,
//   avatarUrl,
//   username,
//   fetchUsers,
//   userId,
// }) => {
//   const [idBtnLoading, setIdBtnLoading] = useState(false);

//   const userMarkedAsdeleted = () => {
//     let config = {
//       method: "put",
//       maxBodyLength: Infinity,
//       url: `${process.env.REACT_APP_API_URL}/account-delete/markAsDeleted/${userId}`,
//       headers: {},
//       data: "",
//     };

//     axios
//       .request(config)
//       .then((response) => {
//         console.log(response.data);
//         setIdBtnLoading(false);
//         handleClose();
//         fetchUsers();
//       })
//       .catch((error) => {
//         console.log(error);
//       });
//   };

//   return (
//     <Modal
//       open={warnPopupOpen}
//       onClose={handleClose}
//       aria-labelledby="modal-modal-title"
//       aria-describedby="modal-modal-description"
//     >
//       <Box sx={style}>
//         <div className="w-full">
//           <div className="mb-4 flex items-center">
//             <img
//               src={avatarUrl}
//               alt="Avatar"
//               className="mr-2 h-14 w-14 rounded-full"
//             />
//             <h2 className="text-xl font-semibold tracking-wide">{username}</h2>
//           </div>
//           <p className="mb-6 tracking-wide">Do you want to delete this user?</p>
//           <div className="flex justify-end space-x-4 tracking-wide">
//             <button
//               className="rounded bg-gray-300 px-4 py-2 text-gray-800 hover:bg-gray-400"
//               onClick={handleClose}
//             >
//               Cancel
//             </button>

//             {idBtnLoading ? (
//               <button className="rounded bg-[#c51369] px-4 py-2 text-white hover:bg-[#a10f5b]">
//                 <BtnLoader />
//               </button>
//             ) : (
//               <button
//                 onClick={userMarkedAsdeleted}
//                 className="rounded bg-[#c51369] px-4 py-2 text-white hover:bg-[#a10f5b]"
//               >
//                 Delete
//               </button>
//             )}
//           </div>
//         </div>
//       </Box>
//     </Modal>
//   );
// };

// export default WarningPopup;
